import React, { useState, useEffect } from "react";
import { Input, Button, Form, Col, Row, message } from "antd";
import axios from "axios";
import { baseURL } from "../../globalUtils/axiosConfig";

const STORAGE_KEY = "app_version_data";

const AppVersionTable = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const localData = localStorage.getItem(STORAGE_KEY);
    if (localData) {
      const parsed = JSON.parse(localData);
      form.setFieldsValue({
        teacherAndroid: parsed.teacher_android_version || "",
        teacherIos: parsed.teacher_ios_version || "",
        communityAndroid: parsed.community_android_version || "",
        communityIos: parsed.community_ios_version || "",
      });
    }
  }, [form]);

  useEffect(() => {
    const fetchAppVersion = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/v2/app_version`);

        const data = response?.data?.data?.version;
        if (data) {
          form.setFieldsValue({
            teacherAndroid: data.teacher_android_version || "",
            teacherIos: data.teacher_ios_version || "",
            communityAndroid: data.community_android_version || "",
            communityIos: data.community_ios_version || "",
          });

          localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        }
      } catch (error) {
        console.error("Error fetching app version:", error);
        message.error("Failed to load app version data.");
      }
    };

    fetchAppVersion();
  }, [form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        teacher_android_version: values.teacherAndroid,
        teacher_ios_version: values.teacherIos,
        community_android_version: values.communityAndroid,
        community_ios_version: values.communityIos,
      };

      const response = await axios.post(
        `${baseURL}/api/v2/app_version`,
        payload
      );

      if (response.data?.success) {
        message.success("App version updated successfully!");

        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } else {
        message.error("Failed to update app version.");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong while updating app version.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-top-div">
      <span className="text-span">App Version</span>
      <Row justify="center" className="production-manager-parent-row">
        <Col lg={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{ maxWidth: "400px" }}
          >
            <Form.Item
              label="Teacher Android Version"
              name="teacherAndroid"
              // required={false}
              // rules={[{ required: true, message: "Required!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Teacher iOS Version"
              name="teacherIos"
              // required={false}
              // rules={[{ required: true, message: "Required!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Community Android Version"
              name="communityAndroid"
              // required={false}
              // rules={[{ required: true, message: "Required!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Community iOS Version"
              name="communityIos"
              // required={false}
              // rules={[{ required: true, message: "Required!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit" loading={loading}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default AppVersionTable;